import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import UserInfoData from "../../../../Components/UserInfoData/UserInfoData";
import { Roles, WebRoutes } from "../../../../Constants";
import "./UserProfilePage.scss";

export function UserProfilePage() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user.credentials);

  const [userInfo, setUserInfo] = useState({
    id: "",
    firstName: "",
    lastName: "",
    preposition: "",
    role: 0,
    schoolId: "",
    softEmail: "",
    course: "",
    class: "",
    iddinkCode: "",
    email: "",
  });

  useEffect(() => {
    if (userData.role === Roles.Admin) {
      parseUserInfo();
    } else {
      switch (userData.role) {
        case Roles.Admin:
          navigate(WebRoutes.UserHomePage);
          break;

        case Roles.SchoolManager:
          navigate(WebRoutes.SchoolHomePage);
          break;

        case Roles.SchoolBookManager:
          navigate(WebRoutes.SchoolHomePage);
          break;

        case Roles.Student:
          navigate(WebRoutes.StudentHomePage);
          break;

        default:
          navigate(-1);

          break;
      }
    }
  }, []);

  const parseUserInfo = () => {
    setUserInfo({ ...userInfo, ...userData });
  };

  return (
    <div className="user-profile-page">
      <div className="header">
        <div className="title">{t("ProfilePageTitle")}</div>
        {/* <div className="description">{t("ProfilePageSubtitle")}</div> */}
      </div>
      <div className="block-wrapper">
        <div className="block-info">
          <UserInfoData userInfo={userInfo} />
          {!userData.isExternalUser && (
            <div className="button-wrapper">
              <Button
                className="button"
                onClick={() => navigate(WebRoutes.ChangePasswordPage)}
              >
                {t("ChangePassword")}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
